export default (root: string) => ({
    deployments: `${root}/deployments`,
    deployment: (deploymentId: string) => {
        const specificRoot = `${root}/deployments/${deploymentId}`;
        return {
            root: specificRoot,
        };
    },
});
